import React, { useState, useEffect, useMemo } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

// assets
import Icon from "../media/icon/icons";
import Company_Logo_short from "../media/image/axi_wideLogo.png";
import LoginDotBG from "../media/image/login-dot-bg.png";
import certificates from "../media/image/certificates.png";
import LoginLine from "../media/image/login-line.png";

// styles & components
import "../styles/pages.css";
import Button from "../components/utilitis/Button.jsx";
import AuthAnimation from "../components/Animation/AuthAnimation.jsx";
import Loader from "../components/utilitis/Loader.jsx";
import ModalForAuth from "../components/modals/modalforauth.jsx";
import Errorbox from "../components/utilitis/ErrorBox.jsx";

import {
  EmailInput,
  PasswordInput,
} from "../components/utilitis/inputs/Input.jsx";
import {
  validateName,
  validateEmail,
  validatePassword,
  validateCompanyName,
  validateContact,
  validateCompanyURL,
  validateCountry,
} from "../components/utilitis/validators.jsx";

// services
import { login } from "../services/authService";

const Auth = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [formState, setFormState] = useState({
    name: "",
    email: "",
    contact: "",
    country: "",
    password: "",
    company_url: "",
    company_name: "",
    cnf_password: "",
  });

  const [errors, setErrors] = useState({
    login: {},
    signup: {},
  });
  const [activePage, setActivePage] = useState("login");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorIcon, setErrorIcon] = useState(null);

  const currentYear = useMemo(() => new Date().getFullYear(), []);

  useEffect(() => {
    const formParam = new URLSearchParams(location.search).get("form");
    const newPage = formParam === "signup" ? "signup" : "login";
    setActivePage(newPage);
  }, [location.search]);



  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState((prevState) => ({ ...prevState, [name]: value }));

    if (name === "email") {
      const { valid, message } = validateEmail(value);
      setErrors((prev) => ({ ...prev, email: valid ? "" : message }));
    } else if (name === "name") {
      const { valid, message } = validateName(value);
      setErrors((prev) => ({ ...prev, name: valid ? "" : message }));
    } else if (name === "password" || name === "cnf_password") {
      const password = name === "password" ? value : formState.password;
      const confirmPassword =
        name === "cnf_password" ? value : formState.cnf_password;

      const { valid, message } = validatePassword(password);

      let passwordError = valid ? "" : message;
      let matchError =
        password && confirmPassword && password !== confirmPassword
          ? "Passwords do not match"
          : "";

      setErrors((prev) => ({
        ...prev,
        password: passwordError || matchError,
        cnf_password: matchError,
      }));
    } else if (name === "company_name") {
      const { valid, message } = validateCompanyName(value);
      setErrors((prev) => ({ ...prev, company_name: valid ? "" : message }));
    } else if (name === "contact") {
      const { valid, message } = validateContact(value);
      setErrors((prev) => ({ ...prev, contact: valid ? "" : message }));
    } else if (name === "company_url") {
      const { valid, message } = validateCompanyURL(value);
      setErrors((prev) => ({ ...prev, company_url: valid ? "" : message }));
    } else if (name === "country") {
      const { valid, message } = validateCountry(value);
      setErrors((prev) => ({ ...prev, country: valid ? "" : message }));
    } else {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  // Handle login
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorIcon(null);

    const emailCheck = validateEmail(formState.email);
    const passwordCheck = validatePassword(formState.password);

    if (!emailCheck.valid || !passwordCheck.valid) {
      setErrors({
        login: {
          email: emailCheck.valid ? "" : emailCheck.message,
          password: passwordCheck.valid ? "" : passwordCheck.message,
        },
        signup: errors.signup,
      });
      setLoading(false);
      return;
    }

    try {
      const response = await login(formState.email, formState.password);
      navigate("/home");
    } catch (err) {
      setErrors("Invalid credentials.");
      setErrorIcon("fail");
    } finally {
      setLoading(false);
    }
  };


  

  return (
    <div className="auth-wrapper">
      {typeof errors === "string" && (
        <Errorbox title={errors} iconStatus={errorIcon} />
      )}
      <ModalForAuth
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        defaultEmail={formState.email}
        modalType={modalType}
      />

      {/* login UI */}
      <div className="auth-page">
        <div className="wrap">
          <div className="auth-left">
            <div className="auth-left-container-screen">
              <div className="auth-left-header">
                <img
                  className="companyFullWideLogo"
                  src={Company_Logo_short}
                  alt="company logo"
                />
                {activePage === "signup" ? (
                  <h2>Let's get started!</h2>
                ) : (
                  <h2>Back in action!</h2>
                )}
                <p className="lastLine">
                  Your gateway to effortless management.
                </p>
              </div>

              <div className="auth-left-body">
                <AuthAnimation />
              </div>

              <div className="auth-left-footer">
                <div className="auth-sign">
                  <p className="firstLine">Seamless Collaboration</p>
                  <img src={LoginLine} alt="auth line" />
                </div>
                <p className="lastLine">
                  Effortlessly work together with your team in real-time.
                </p>
              </div>
            </div>
          </div>

          <div className="auth-right">
            {/* Form Buttons*/}
            {/* <div className="form-btn-container">
							<div className={`auth-buttons ${activePage === "signup" ? "signup-active" : "login-active"} ${hasSwitched ? "with-animation" : ""}`} >
								<button
									onClick={() => handlePageSwitch("login")}
									className={activePage === "login" ? "auth-active" : ""}
								>
									Login
								</button>
								<button
									onClick={() => handlePageSwitch("signup")}
									className={activePage === "signup" ? "auth-active" : ""}
								>
									Sign up
								</button>
							</div>
						</div> */}
            <div className="form-btn-container">
              <div className="auth-buttons single-auth">
                <button className="auth-active">Login</button>
              </div>
            </div>

            {/* Login Form */}
            <div
              className={`form-wrapper ${
                activePage === "login" ? "auth-active" : "inactive"
              }`}
            >
              <form className="login-form">
                <div>
                  <EmailInput
                    name="email"
                    placeholder="Email"
                    value={formState.email}
                    onChange={handleChange}
                    helpText={errors.login?.email}
                    // helpText={"Hello"}
                    required={true}
                  />
                  <div className="inputStablizer">
                    <PasswordInput
                      name="password"
                      placeholder="Password"
                      value={formState.password}
                      onChange={handleChange}
                      onPaste={(e) => e} // Explicitly allow paste
                      helpText={errors.login?.password}
                      required={true}
                    />

                    {/* <PasswordInput
											name='password'
											placeholder='Password'
											value={formState.password}
											onChange={handleChange}
											onPaste={(e) => e} // Explicitly allow paste
											helpText={errors.login?.password}
											required={true}
											/> */}
                  </div>
                 
                </div>

                <div>
                  <Button
                    className="auth_btn"
                    type="submit"
                    backgroundcolor="#007bff"
                    size="large"
                    textColor="#ffffff"
                    onClick={handleLogin}
                  >
                    <span>Log In</span>
                    {loading ? (
                      <Loader strokeColor="#fafafa" width={20} height={20} />
                    ) : (
                      <>
                        <Icon
                          name="auth_btn_right_arrow"
                          width={20}
                          height={20}
                          color="#ffffff"
                        />
                      </>
                    )}
                  </Button>
                 
                </div>
              </form>
            </div>


            {/* Auth fotter */}
            <div className="auth-right-footer">
              <div className="certificates">
                <img src={certificates} alt="" />
                <p>{currentYear} Axipays. All rights reserved.</p>
              </div>

              <p className="company_tagline">Your Global Payment Processor</p>
            </div>

            {/* Auth-Right BG */}
            <div className="authRight-page-dotBackground">
              <img src={LoginDotBG} alt="Login Dot Background" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
